import { IconButton, Skeleton } from '@mui/material';
import DeliverableInfo from '../../../components/deliverables/deliverables';
import * as Utility from '../../../core/utility';
import { ChevronLeft, Close, Share } from '@mui/icons-material';
import InstagramIcon from '../../../components/icons/instagram-icon';
import YouTubeIcon from '@mui/icons-material/YouTube';
import MaterialSymbol from '../../../components/icons/material-symbol';
import dayjs from 'dayjs';
import { InfluencerCampaignCard } from '../../../components';
const methods: Utility.Methods = new Utility.Methods();

type Props = {
    handleCampaignDetailPopupClose: any;
    campaign_id: number;
    data: any;
    loading: Boolean;
    handleClickShare: any;
    handleCampaignApply: any;
    btnName:string;
    // userReducer:any;
    // checkInfType:any;
    // handleCampaign:any
}

const CampaignDetailMobileDrawer = ({ handleCampaignDetailPopupClose, campaign_id, data, loading, handleCampaignApply, handleClickShare, btnName }: Props) => {
    const res = data?.data?.rows;
   const deliverablesList: any = [
    ...new Set(
        (res?.deliverables || []).flatMap((item: any) =>
        item?.deliverables || []
        )
    ),
    ];
    return (
        <div className="mobile-drawer">
            {/* HEADER */}
            <div className="mobile-header">
                <IconButton
                    onClick={() =>
                        handleCampaignDetailPopupClose(campaign_id)
                    }
                >
                    <ChevronLeft />
                </IconButton>
                <h3>Campaign Details</h3>
                <IconButton
                    onClick={(event) =>
                        handleClickShare(event, data)
                    }
                >
                    <Share />
                </IconButton>
            </div>
<div className="d-flex gap-3">
            {/* IMAGE */}
            <div className="mobile-image">
                <img src={res?.campaign_cover_url} alt="" />
                {/* <span className="badge">{res?.campaign_type}</span> */}
                
            </div>
            <div className="d-flex flex-column align-items-start gap-1">
                {loading ? <Skeleton animation="wave" /> :
                    <span className='badge badge-primary-outline btn-sm'>
                        {(
                            res?.campaign_platform + ''
                        ).toLocaleLowerCase() === 'instagram' ? (
                            <InstagramIcon width="16px" height="16px" />
                        ) : (
                            <YouTubeIcon width="20px" height="20px" />
                        )}

                        {res?.campaign_type
                        }
                    </span>
                }
                {/* TITLE */}
                <h2 className='mt-0'>{res?.campaign_title}</h2>
                <p className="posted">
                    Posted {methods.calculateDaysDifference(new Date(res?.posted_at), new Date())} days ago
                </p>
            </div>
</div>
            {/* DESCRIPTION */}
            <h4>Description</h4>
<InfluencerCampaignCard
                    description=
                    {loading ? <Skeleton animation="wave" /> : res?.campaign_description
                    }
                     about_brand=
                    {loading ? <Skeleton animation="wave" /> : res?.about_brand
                    }
                    updated_at={loading ? <Skeleton animation="wave" /> :
                      res?.updated_at
                    }
                  />
            {/* DELIVERABLES */}
               
            {/* <div className="camp-detail-card-inner grid-3-col ">
                <DeliverableInfo deliverablesData={res} />
            </div> */}
            
                        <div className='camp-detail-card grid-2-row'>
                            <div className='infl-det-list-sec proposal-dur-info'>
                              {res?.proposal_dt &&
                                <div className='infl-det-list'>
                                  <div className='infl-det-list-icon'>
                                    <span className='material-symbols-rounded'>
                                      alarm
                                    </span>
                                  </div>
                                  <div className='infl-det-list-content'>
                                    <ul>
                                      <li>Proposal Deadline</li>
                                    </ul>
                                    <strong>{loading ? <Skeleton animation="wave" /> : dayjs(res?.proposal_dt).format('LL')} </strong>
                                  </div>
                                </div>
                              }
                              {res?.go_live_dt &&
                                <div className='infl-det-list'>
                                  <div className='infl-det-list-icon'>
                                    <span className='material-symbols-rounded'>
                                      calendar_month
                                    </span>
                                  </div>
                                  <div className='infl-det-list-content'>
                                    <ul>
                                      <li>Campaign Live Date</li>
                                    </ul>
                                    <strong>{loading ? <Skeleton animation="wave" /> : dayjs(res?.go_live_dt).format('LL')}</strong>
            
            
                                  </div>
                                </div>
                              }
            
            
                            </div>
                          </div>
                
            {/* INFLUENCER DETAILS */}
            <div className="infl-detail-sec">
                <h4>Influencer Details</h4>

                {/* Gender */}
                <div className="info-card">
                    <div className="info-header">
                    <span className="icon"><MaterialSymbol iconName='person' fontweight='200' /></span>
                    <span className="label">Gender</span>
                    </div>
                    <div className="value">{res?.influencer_gender}</div>
                </div>

                {/* Category */}
                <div className="info-card">
                    <div className="info-header">
                    <span className="icon"><MaterialSymbol iconName='category' fontweight='200' /></span>
                    <span className="label">Category</span>
                    </div>
                    <div className="value">
                    {res?.categories}
                    </div>
                </div>

                {/* Location */}
                <div className="info-card">
                    <div className="info-header">
                    <span className="icon"><MaterialSymbol iconName='location_on' fontweight='200' /></span>
                    <span className="label">Location</span>
                    </div>
                    <div className="value">
                    {methods.formatGroupLocations(res?.group_locations).join('; ')}
                    </div>
                </div>
                </div>
            <h4>Deliverables</h4>
                <div className="deliverable-card">
                <ul>
                    {deliverablesList.map((d: string, i: number) => (
                        <li key={i}>{d}</li>
                    ))}
                </ul>
                </div>
            {/* FIXED FOOTER */}
            <div className="mobile-footer">
                <button className="btn btn-primary" onClick={handleCampaignApply}>{btnName}</button>
            </div>
        </div>
    );
};

export default CampaignDetailMobileDrawer;